import { AxiosRequestConfig } from 'axios'

const getPrizes = (count = -1): AxiosRequestConfig => ({
  url: `/prizes/list`,
  method: 'GET',
  params: {
    count
  }
})

export { getPrizes }
